/**
 * Edge Auth (Edge Router Worker) との接続用フロントエンド共有定数
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Infrastructure
 * @graph-business Edge Router Worker の OAuth start URL を web アプリ間で共有する定数とヘルパー
 * @graph-connects none
 */
/**
 * Edge Auth Worker の OAuth 開始エンドポイント URL
 *
 * Worker (`apps/worker/edge-router/src/auth/`) が `auth.air-closet.ai/__edge/auth/start`
 * で Google OAuth start を受ける。各 web アプリはここに `?return=<元URL>` を付けて
 * フルページ遷移する。
 *
 * @graph-connects none
 */
export const EDGE_AUTH_START_URL = 'https://auth.air-closet.ai/__edge/auth/start';
/**
 * Edge Auth start URL に return param を付けて完全な URL を組み立てる。
 *
 * @param returnUrl 認証完了後に戻りたい URL (通常 `window.location.href`)
 * @graph-connects none
 */
export function buildEdgeAuthStartUrl(returnUrl) {
    const url = new URL(EDGE_AUTH_START_URL);
    url.searchParams.set('return', returnUrl);
    return url.toString();
}
//# sourceMappingURL=edge-auth.js.map